import { MessageDescriptor } from 'react-intl';
import { camelize } from 'lib/utility';
import { getIntlMessage } from './shared';
import { defaultMessages } from './default';

const getCommonLocale = (
  kind: string,
  key: string,
): MessageDescriptor => {
  const intlMessage = getIntlMessage('common', '', kind, key);

  return defaultMessages[camelize(intlMessage)];
};

export default getCommonLocale;
